import React, {Component} from 'react';
import trainingProgramsActionCreators from "../../store/training-programs/action-creators";
import {connect} from "react-redux";
import './StartOfTraining.scss';

class StartOitTraining extends Component {

  constructor(props) {
    super(props);
    this.props.fetchTrainingPrograms();
  }

  get currentTrainingPrograms() {
    return this.props.trainingPrograms
      && this.props.trainingPrograms.filter(tp => tp.status === 'current')
    || []
  }

  render() {
    return (
      <div className="start-of-training">
        { this.currentTrainingPrograms.map(tp => (
          <div className="training-program"  key={tp.guid}>
            <span>{tp.title}</span>
            <button
              data-tip="Start program"
              className="button small default"
              onClick={() => this.props.onSelect(tp)}
            >
              <i className="fa fa-play"/>
            </button>
          </div>
        ))}
      </div>
    )
  }

}

const mapStateToProps = (state) => {
  return { trainingPrograms: state.trainingPrograms.list };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTrainingPrograms: () => {
      return dispatch(trainingProgramsActionCreators.fetchTrainingPrograms());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(StartOitTraining);